module.exports = __webpack_public_path__ + "HRA Brochure - percent based.pdf";